import * as actionTypes from "./constants";
import { sortData } from "../../screens/Config/utils";
const initialState = {
  processing: false,
  error: false,
  paymentMode1: [{ value: "", name: "All" }],
  paymentMode: [],
};

export default function runnerPaymentsReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.FETCH_RECEIVEDPAYMENTS_SUCCESS_ACTION:
      return {
        ...state,
        processing: false,
        receivedpaymentsList: action.payload.rows,
        receivedpaymentsCount: action.payload.count,
      };
    case actionTypes.FETCH_GENERATEDPAYMENTS_SUCCESS_ACTION:
      return {
        ...state,
        processing: false,
        generatedpaymentsList: action.payload.rows,
        generatedpaymentsCount: action.payload.count,
      };
    case actionTypes.FETCH_RUNNERPAYMENTMODE_SUCCESS_ACTION:
      let tempPaymentModeData = sortData(action.paymentMode);
      return {
        ...state,
        paymentModeList: action.payload.rows,
        paymentMode: [...state.paymentMode1, ...tempPaymentModeData],
      };

    case actionTypes.FETCH_RECEIVEDPAYMENTS_INIT_ACTION:
      return {
        ...state,
        processing: true,
      };

    case actionTypes.FETCH_GENERATEDPAYMENTS_INIT_ACTION:
      return {
        ...state,
        processing: true,
      };

    default:
      return {
        ...state,
      };
  }
}
